const COLOR = {
  packageExpiringSoon: '#FF692E',
  backgroundDoubleChar: '#007AFF0A',
  borderDoubleChar: '#007AFF29',
  backgroundActiveVoice: '#ffd60a14',
  borderActiveVoice: '#ffd60a',
  boxShadow: '#00000014',
  colorFilterInput: '#1E164EA3',
  borderFilterInput: '#3C3C4329',
  tagNew: '#FF2D55',
  green: '#16B364',
  borderDropdown: '#1E164E29',
  colorVoiceCard: '#3C3C43A3',
  borderPromoEarnings: '#FFD60A52',
  backgroundPromoEarnings: '#FFD60A14',
  navyBlue: '#1E164ECC',
  backgroundDefault: '#F4F5F7',
  backgroundPending: '#007AFF14',
  backgroundApproved: '#34C75914',
  backgroundRejected: '#FF3B3014',
  backgroundWarning: '#FF950014',
  textPending: '#007AFF',
  textApproved: '#34C759',
  textRejected: '#FF3B30',
  textWarning: '#FF9500',
  descriptionVoiceStatus: '#000000A3',
  borderPromoVoice: '#ff2d5529',
  borderButtonDisabled: 'rgba(0, 0, 0, 0.12)',
  backgroundLinearProgress: '#1E164E14',
  colorGrayV2: '#1C1C1E7A',
  backgroundRecordTimeHover: '#9b9b9b2b',
  backgroundSuccess: '#34C75914',
  infoNoiseReduction: '#007AFF14',
  borderButton: '#e0e0e0',
  backgroundError: '#FF3B3014',
  backgroundRecordTime: '#1E164E0A',
  backgroundDropZone: '#F4F5F7A3',
  errorDropZone: '#FF3B30',
  borderDropZone: '#3C3C4352',
  descriptionUpload: '#1C1C1EA3',
  borderButtonCorlor: '#1E164E52',
  colorIcon: '#101323',
  indigoIcon: '#1E164EA3',
  descriptionGray: '#1C1C1E',
  bgRedPrimary: '#FF3B3029',
  indigoColor: '#5856D6',
  iconDisabledColor: '#B0ADBF',
  tooltipColor: '#1E164E7A',
  errorHover: '#1e164e29',
  redPrimary: '#ff3b30',
  primaryHover: '#ffe66c',
  white: '#ffffff',
  background: '#f8f8f8',
  divider: '#e9ecef',
  lightDivider: '#b9b9c3',
  text: '#242424',
  subText: '#6e6b7b',
  lightText: '#787878',
  blue: '#0061AF',
  blurloading: '#ffffff8a',
  labelBlue: '#117EEF',
  danger: '#ea5455',
  purple: '#8b78cd',
  lightGreen: '#4eb081',
  lightBlue: '#2279c9',
  orange: '#ff9f43',
  red: '#fe0303',
  activeMenu: 'rgba(30, 22, 78, 0.08)',
  darkRed: '#7a211b',
  phoneInput: '#3C3C4329',
  loadingLoadRequest: '#1E164EA3',
  darkBlue: '#1e164e',
  skyBlue: '#bfd9ff',
  paleBlue: '#e6f7ff',
  alert: '#ff9500',
  activeColor: '#D3D1DA',
  primary: '#ffd60a',
  success: '#52C41A',
  error: '#fe0303',
  warning: '#faad14',
  info: '#1890FF',
  dark: '#4b4b4b',
  light: '#babfc7',
  gray: '#E9E9E9',
  charcoal: '#f4f5f7',
  darkGray: '#1C1C1E',
  darkSlate: '#020617',
  midSlate: '#334155',
  graySlate: '#64748B',
  borderSlate: '#E2E8F0',
  lightSlate: '#F8FAFC',
  orange600: '#EA580C',
  amber100: '#FEF3C7',
  amber300: '#FCD34D',
  amber500: '#F59E0B',
  amber900: '#78350F',
  orange50: '#FFF7ED',
  white48: 'rgba(255, 255, 255, 0.48)',
  white60: 'rgba(255, 255, 255, 0.6)',
  white70: 'rgba(255, 255, 255, 0.7)',
  blueV2: '#007AFF',
  blue600: '#1570EF',
  blue700: '#0017E4',
  blueDark: '#004EEB',

  boldSuccess: '#00A442',
  button: 'rgba(0, 0, 0, 0.54)',
  disableButton: 'rgba(0, 0, 0, 0.26)',
  primary40: 'rgba(255, 214, 10, 0.40)',

  rainbow:
    'linear-gradient(100.92deg, #f48b71 -15.23%, #f1414d 42.62%, #563efa 99.91%)',
  gradient:
    'linear-gradient(101deg, rgba(241, 65, 77, 0.08) -15.23%, rgba(255, 255, 255, 0.08) 42.62%, rgba(86, 62, 250, 0.08) 99.91%), #FFF;',

  orangeV2: {
    8: 'rgba(255, 149, 0, 0.08)',
    16: 'rgba(255, 149, 0, 0.16)',
    32: 'rgba(255, 149, 0, 0.32)',
    100: 'rgba(255, 149, 0, 1)',
  },

  orangeDark: {
    64: 'rgba(255, 68, 5, 0.64)',
    80: 'rgba(255, 68, 5, 0.80)',
    100: 'rgba(255, 68, 5, 1)',
  },

  charcoalV2: {
    64: 'rgba(244, 245, 247, 0.64)',
    80: 'rgba(244, 245, 247, 0.8)',
    100: 'rgba(244, 245, 247, 1)',
  },

  bluev2: {
    4: 'rgba(0, 122, 255, 0.04)',
    8: 'rgba(0, 122, 255, 0.08)',
    10: 'rgba(0, 122, 255, 0.1)',
    16: 'rgba(0, 122, 255, 0.16)',
    24: 'rgba(0, 122, 255, 0.24)',
    48: 'rgba(0, 122, 255, 0.48)',
    80: 'rgba(0, 122, 255, 0.80)',
    100: 'rgba(0, 122, 255, 1)',
  },

  secondary: {
    old: '#4b4b4b',
    80: 'rgba(30, 22, 78, 0.08)',
    60: 'rgba(30, 22, 78, 0.06)',
    40: 'rgba(30, 22, 78, 0.04)',
    8: 'rgba(30, 22, 78, 0.8)',
    16: 'rgba(30, 22, 78, 0.16)',
    24: 'rgba(30, 22, 78, 0.24)',
    32: 'rgba(30, 22, 78, 0.32)',
    64: 'rgba(30, 22, 78, 0.64)',
    100: 'rgba(30, 22, 78, 1)',
  },

  black: {
    default: '#000000',
    8: 'rgba(0, 0, 0, 0.08)',
    16: 'rgba(0, 0, 0, 0.16)',
    24: 'rgba(0, 0, 0, 0.24)',
    30: 'rgba(0, 0, 0, 0.30)',
    32: 'rgba(0, 0, 0, 0.32)',
    48: 'rgba(0, 0, 0, 0.48)',
    54: 'rgba(0, 0, 0, 0.54)',
    64: 'rgba(0, 0, 0, 0.64)',
    80: 'rgba(0, 0, 0, 0.8)',
  },

  indigo: {
    default: '#1E164E',
    4: 'rgb(30, 22, 78, 0.04)',
    8: 'rgba(30, 22, 78, 0.08)',
    16: 'rgba(30, 22, 78, 0.16)',
    32: 'rgba(30, 22, 78, 0.32)',
    48: 'rgba(30, 22, 78, 0.48)',
    64: 'rgba(30, 22, 78, 0.64)',
    80: 'rgba(30, 22, 78, 0.80)',
    100: 'rgba(30, 22, 78, 1)',
  },

  label: {
    4: 'rgba(60, 60, 67, 0.04)',
    8: 'rgba(60, 60, 67, 0.08)',
    16: 'rgba(60, 60, 67, 0.16)',
    64: 'rgba(60, 60, 67, 0.64)',
    80: 'rgba(60, 60, 67, 0.80)',
    100: 'rgba(60, 60, 67, 1)',
  },

  label2: {
    100: 'rgba(28, 28, 30, 1)',
    24: 'rgba(28, 28, 30, 0.24)',
    64: 'rgba(28, 28, 30, 0.64)',
    50: 'rgba(28, 28, 30, 0.50)',
    48: 'rgba(28, 28, 30, 0.48)',
  },

  functionalRed: {
    default: '#ff3b30',
    32: 'rgba(255, 59, 48, 0.32)',
    8: 'rgba(255, 59, 48, 0.08)',
    16: 'rgba(255, 59, 48, 0.16)',
  },
  functionalPink: {
    default: '#FF2D55',
    4: 'rgba(255, 45, 85, 0.04)',
    16: 'rgba(255, 45, 85, 0.16)',
  },

  functionYellow: {
    default: '#FFCC00',
    16: 'rgba(255, 204, 0, 0.16)',
    64: 'rgba(255, 204, 0, 0.64)',
    100: 'rgba(255, 204, 0, 1)',
  },

  yellow: {
    default: '#FFD60A',
    64: 'rgba(255, 214, 10, 0.64)',
    32: 'rgba(255, 214, 10, 0.32)',
    16: 'rgba(255, 214, 10, 0.16)',
    8: 'rgba(255, 214, 10, 0.08)',
  },

  darkV2: {
    default: '#3C3C43',
    8: 'rgba(60, 60, 67, 0.08)',
    16: 'rgba(60, 60, 67, 0.16)',
    32: 'rgba(60, 60, 67, 0.32)',
    60: 'rgba(60, 60, 67, 0.60)',
    64: 'rgba(60, 60, 67, 0.64)',
    80: 'rgba(60, 60, 67, 0.80)',
  },

  grayV2: {
    50: 'rgba(246, 246, 248)',
    100: 'rgba(237, 237, 241)',
    150: 'rgba(219, 217, 226)',
  },

  whiteV2: {
    default: '#FFFFFF',
    64: 'rgba(255, 255, 255, 0.64)',
  },

  greenV2: {
    default: '#34c759',
    8: 'rgba(52, 199, 89, 0.08)',
  },

  purpleV2: {
    default: '#6746F5',
    10: 'rgba(103, 70, 245, 0.1)',
    30: 'rgba(103, 70, 245, 0.5)',
  },
  pink: {
    8: 'rgba(255, 45, 85, 0.08)',
  },
};

const TRANSPARENT_COLOR = {
  primary: 'rgba(255, 214, 10, 0.20)',
  secondary: 'rgba(108, 117, 125, 0.05)',
  success: 'rgba(40, 199, 111, 0.12)',
  error: 'rgba(234, 84, 85, 0.12)',
  warning: 'rgba(255, 225, 67, 0.12)',
  info: 'rgba(0, 207, 232, 0.12)',
  dark: 'rgba(30, 30, 30, 0.05)',
  light: 'rgba(186, 191, 199, 0.12)',
  lightOrange: 'rgba(252, 102, 52, 0.25)',
  red: 'rgb(254, 3, 3, 0.12)',
  darkBlue: 'rgba(30, 22, 78, 0.32)',
  borderGray: 'rgba(60, 60, 67, 0.16)',
  bgrGray: 'rgba(30, 22, 78, 0.04)',
  alert: 'rgba(255, 149, 0, 0.08)',
  lightGray: 'rgba(0, 0, 0, 0.26)',
};

const GRADIENT_COLOR = {
  primary: 'linear-gradient(45deg, #fc6634 0%, #fe506a 100%)',
  secondary: 'linear-gradient(45deg, #82868b 0%, #9ca0a4 100%)',
  success:
    'linear-gradient(45.79deg, #28c76f 0%, #48da89 94.75%, #48da89 94.75%)',
  error: 'linear-gradient(43.96deg, #ea5455 2.91%, #f08182 94.71%)',
  warning: 'linear-gradient(41.83deg, #ffe143 2.18%, #ffbc0e 97.5%)',
  info: 'linear-gradient(45deg, #00cfe8 0%, #1ce7ff 100%)',
  dark: 'linear-gradient(48.35deg, #4b4b4b 0%, #787878 94.43%)',
  orange: 'linear-gradient(to right, #ffca44 9.97%, #ff9920 97.59%)',
  darkBlue: 'linear-gradient(to right, #1e164e 9.97%, #1e164e 97.59%)',
  orangeRed: 'linear-gradient(212.33deg, #fc6634 -2.88%, #fc9434 103.36%)',
  blueGradient: 'linear-gradient(207.04deg, #007aff 2.76%, #1a37e1 80.69%)',
};

const LINEAR_COLOR = {
  info: {
    text: 'rgba(0, 122, 255, 1)',
    background: 'rgba(50, 173, 230, 0.08)',
    linear: 'rgba(0, 122, 255, 0.16)',
  },
};

const CONTAINED_BUTTON_COLOR = {
  primary: {
    hover: '#FFE66C',
    active: '#ffe86d',
    focus: '#ffe86d',
  },
  secondary: {
    hover: '#4a4a4a',
    active: '#242424',
    focus: '#75797e',
  },
  success: {
    hover: '#28c76f',
    active: '#24b263',
    focus: '#24b263',
  },
  error: {
    hover: '#ea5455',
    active: '#e73d3e',
    focus: '#e73d3e',
  },
  warning: {
    hover: '#ffe86d',
    active: '#ffe143',
    focus: '#ffd600',
  },
  info: {
    hover: '#00cfe8',
    active: '#00b8cf',
    focus: '#00b8cf',
  },
  dark: {
    hover: '#4b4b4b',
    active: '#343434',
    focus: '#343434',
  },
};

const OUTLINED_BUTTON_COLOR = {
  primary: {
    hover: 'rgba(30, 22, 78, 0.1)',
    active: 'rgba(30, 22, 78, 0.1)',
    focus: 'rgba(30, 22, 78, 0.1)',
  },
  secondary: {
    hover: 'rgba(108, 117, 125, 0.04)',
    active: 'rgba(108, 117, 125, 0.1)',
    focus: 'rgba(108, 117, 125, 0.2)',
  },
  success: {
    hover: 'rgba(40, 199, 111, 0.04)',
    active: 'rgba(40, 199, 111, 0.2)',
    focus: 'rgba(40, 199, 111, 0.2)',
  },
  error: {
    hover: 'rgba(234, 84, 85, 0.04)',
    active: 'rgba(234, 84, 85, 0.2)',
    focus: 'rgba(234, 84, 85, 0.2)',
  },
  warning: {
    hover: 'rgba(255, 225, 67, 0.04)',
    active: 'rgba(255, 225, 67, 0.2)',
    focus: 'rgba(255, 225, 67, 0.2)',
  },
  info: {
    hover: 'rgba(0, 207, 232, 0.04)',
    active: 'rgba(0, 207, 232, 0.2)',
    focus: 'rgba(0, 207, 232, 0.2)',
  },
  dark: {
    hover: 'rgba(30, 30, 30, 0.04)',
    active: 'rgba(30, 30, 30, 0.2)',
    focus: 'rgba(30, 30, 30, 0.2)',
  },
};

const TEXT_BUTTON_COLOR = {
  primary: {
    hover: 'rgba(30, 22, 78, 0.1)',
    active: 'rgba(30, 22, 78, 0.1)',
    focus: 'rgba(30, 22, 78, 0.1)',
  },
  secondary: {
    hover: 'rgba(108, 117, 125, 0.12)',
    active: 'rgba(108, 117, 125, 0.2)',
    focus: 'rgba(108, 117, 125, 0.2)',
  },
  success: {
    hover: 'rgba(40, 199, 111, 0.12)',
    active: 'rgba(40, 199, 111, 0.2)',
    focus: 'rgba(40, 199, 111, 0.2)',
  },
  error: {
    hover: 'rgba(234, 84, 85, 0.12)',
    active: 'rgba(234, 84, 85, 0.2)',
    focus: 'rgba(234, 84, 85, 0.2)',
  },
  warning: {
    hover: 'rgba(255, 225, 67, 0.12)',
    active: 'rgba(255, 225, 67, 0.2)',
    focus: 'rgba(255, 225, 67, 0.2)',
  },
  info: {
    hover: 'rgba(0, 207, 232, 0.12)',
    active: 'rgba(0, 207, 232, 0.2)',
    focus: 'rgba(0, 207, 232, 0.2)',
  },
  dark: {
    hover: 'rgba(75, 75, 75, 0.12)',
    active: 'rgba(75, 75, 75, 0.2)',
    focus: 'rgba(75, 75, 75, 0.2)',
  },
};

const GRADIENT_BUTTON_COLOR = {
  primary: {
    hover: 'linear-gradient(46.62deg,#ff4000 0%, #ff2647; 93.64%)',
    active: 'linear-gradient(45deg, #fc6634 0%, #fe506a 100%)',
    focus: 'linear-gradient(45deg, #ff3d06 0%, #ff0026 100%)',
  },
  secondary: {
    hover: 'linear-gradient(45deg, #82868b 0%, #9ca0a4 100%)',
    active: 'linear-gradient(47.52deg, #696d71 0%, #82868b 95.97%)',
    focus: 'linear-gradient(47.52deg, #696d71 0%, #82868b 95.97%)',
  },
  success: {
    hover:
      'linear-gradient(46.82deg, #28c76f 0%, #48da89 93.46%, #48da89 93.46%)',
    active: 'linear-gradient(45deg, #1f9d57 0%, #28c76f 100%)',
    focus: 'linear-gradient(45deg, #1f9d57 0%, #28c76f 100%)',
  },
  error: {
    hover: 'linear-gradient(49.38deg, #ea5455 0.32%, #f08182 93.45%)',
    active: 'linear-gradient(45deg, #e42728 0.32%, #ea5455 100%)',
    focus: 'linear-gradient(45deg, #e42728 0.32%, #ea5455 100%)',
  },
  warning: {
    hover: 'linear-gradient(48.12deg, #ffe143 1.18%, #ffbc0e 95.16%)',
    active: 'linear-gradient(45deg, #ffe143 0.32%, #ffbc0e 100%)',
    focus: 'linear-gradient(45deg, #ffe143 0.32%, #ffbc0e 100%)',
  },
  info: {
    hover: 'linear-gradient(47.47deg, #00cfe8 1.18%, #03e4ff 96.09%)',
    active: 'linear-gradient(45deg, #00b8cf 0.32%, #00cfe8 100%)',
    focus: 'linear-gradient(45deg, #00b8cf 0.32%, #00cfe8 100%)',
  },
  dark: {
    hover: 'linear-gradient(48.13deg, #4b4b4b 1.18%, #787878 94.3%)',
    active: 'linear-gradient(44.76deg, #1e1e1e 1.18%, #4b4b4b 164.14%)',
    focus: 'linear-gradient(44.76deg, #1e1e1e 1.18%, #4b4b4b 164.14%)',
  },
};

export {
  COLOR,
  TRANSPARENT_COLOR,
  GRADIENT_COLOR,
  CONTAINED_BUTTON_COLOR,
  OUTLINED_BUTTON_COLOR,
  TEXT_BUTTON_COLOR,
  GRADIENT_BUTTON_COLOR,
  LINEAR_COLOR,
};
